var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "flex flex-col gap-2" }, [
    !_vm.hasPassword
      ? _c("p", { staticClass: "text-muted mb-1" }, [
          _vm._v(
            " Sua conta entra com o Google e não tem senha. Se quiser também poder entrar com e-mail e senha, defina uma aqui. "
          ),
        ])
      : _vm._e(),
    _vm.hasPassword
      ? _c(
          "div",
          [
            _c("vs-input", {
              staticClass: "w-full",
              attrs: {
                label: "Senha Atual",
                placeholder: "Digite sua senha atual.",
                type: "password",
                id: "current_password",
                name: "current_password",
              },
              model: {
                value: _vm.current_password,
                callback: function ($$v) {
                  _vm.current_password = $$v
                },
                expression: "current_password",
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _c(
      "div",
      [
        _c("vs-input", {
          directives: [
            {
              name: "validate",
              rawName: "v-validate",
              value: "verify_password",
              expression: "'verify_password'",
            },
          ],
          ref: "password",
          staticClass: "w-full",
          attrs: {
            label: _vm.hasPassword ? "Nova Senha" : "Senha",
            placeholder: "Digite sua nova senha.",
            type: "password",
            "data-vv-as": "Senha",
            id: "password",
            name: "password",
          },
          model: {
            value: _vm.password,
            callback: function ($$v) {
              _vm.password = $$v
            },
            expression: "password",
          },
        }),
      ],
      1
    ),
    _c(
      "div",
      [
        _c("vs-input", {
          directives: [
            {
              name: "validate",
              rawName: "v-validate",
              value: "confirmed:password",
              expression: "'confirmed:password'",
            },
          ],
          staticClass: "w-full",
          attrs: {
            label: "Confirmação Nova Senha:",
            placeholder: "Digite a senha novamente.",
            type: "password",
            "data-vv-as": "Confirmação Senha",
            id: "password_confirmation",
            name: "password_confirmation",
          },
          model: {
            value: _vm.password_confirmation,
            callback: function ($$v) {
              _vm.password_confirmation = $$v
            },
            expression: "password_confirmation",
          },
        }),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "pt-8" },
      [
        _c(
          "b-button",
          {
            staticClass: "float-right",
            attrs: { variant: "primary", disabled: !_vm.validPassword },
            on: { click: _vm.changePassword },
          },
          [_vm._v(" Salvar ")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }